import { Injectable } from '@angular/core';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { ShoppingCartService } from '../inventory/shopping-cart.service';
import { AuthService } from './auth.service';

@Injectable()
export class PurchaseConditionService {

    constructor(
        public _api: ApiService,
        private mappings: Mappings,
        private cartService: ShoppingCartService,
        private authService: AuthService,) {
    }

    getPurchaseConditionServiceData(lang: string) {
        let customerId = this.authService.GetUserId();
        let cartId = this.cartService.getCartId();

        let url = this.mappings.Web_Api_Get_Purchase_Condition_Data
            .replace('{lang}', lang)
            .replace('{userid}',customerId)
 	        .replace('{cartid}', cartId);;
        let key = url;

        return this._api.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/purchase-condition.service.ts